import { useNavigate } from "react-router-dom";
import LayoutGeneral from "../LayoutGeneral";
import "./Home.css";

const Home = () => {
  const navigate = useNavigate();
  const EsAdmin = localStorage.getItem("admin");
  const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    const rolUsuario = roles.length > 0 ? roles[0].idRol : null;
const puedeVerReporte = roles.some(role => role.idRol === 1 || role.idRol === 2 || role.idRol === 3);
  const cerrarSesion = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    localStorage.removeItem("idUsuario");
    localStorage.removeItem("nombreUsuario");
    localStorage.removeItem("admin");
    navigate("/");
  };
  // Redireccionamientos
  const GoHome = () => { navigate("/Home"); };
  const GoUsuarios = () => { navigate("/Usuarios"); };
  const GoBitácoras = () => { navigate("/Bitacoras"); };
  const GoIncidencias = () => { navigate("/Incidencias"); };
  return (
    <LayoutGeneral titulo="Home">
      <div className="home-container">
        <aside className="sidebar">
          <ul>
            <li onClick={GoHome}><i className="bi bi-house"></i> Inicio</li>
            {EsAdmin === "1" && (
              <li onClick={GoUsuarios}><i className="bi bi-people"></i> Usuarios</li>)}
               {puedeVerReporte && (
                            <li onClick={GoIncidencias}><i className="bi bi-people"></i> Incidencias</li>
                        )}
            <li onClick={GoBitácoras}><i className="bi bi-journal"></i> Bitácoras</li>
            <li className="logout" onClick={cerrarSesion}> <i className="bi bi-box-arrow-right"></i> Cerrar Sesión </li>
          </ul>
        </aside>

        <main className="main-content">
          <h2>Bienvenido al CRM</h2> 
          <p>Selecciona una opción del menú para comenzar.</p>
        </main>
      </div>
    </LayoutGeneral>
  );
};

export default Home;
